import React, { useEffect, useMemo } from "react";
import { Card, Typography } from "antd";
import { useNavigate, useSearchParams } from "react-router-dom";
import paths from "routes/paths";

const { Text } = Typography;

export default function HelperProfessionProfilesRedirectPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const helperId = searchParams.get("helperId") || null;

  const targetPath = useMemo(
    () =>
      helperId
        ? `${paths.userHelperProfile(helperId)}#profession-profiles`
        : paths.helperRequests,
    [helperId],
  );

  useEffect(() => {
    navigate(targetPath, { replace: true });
  }, [navigate, targetPath]);

  return (
    <div className="container-fluid p-3">
      <Card style={{ maxWidth: 720, margin: "24px auto", borderRadius: 12 }}>
        <Text type="secondary">Redirecting…</Text>
      </Card>
    </div>
  );
}
